import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { VITE_YANDEX_METRICA_ID } from "../../../ENV";

export function YMPageTracker() {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!window.ym) return;

    const currentPath = location.pathname + location.search;

    if (prevPathRef.current !== currentPath) {
      window.ym(VITE_YANDEX_METRICA_ID, "hit", currentPath);

      prevPathRef.current = currentPath;
    }
  }, [location.pathname, location.search]);

  return null;
}
